import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.schoolType.loading;
export const selectErrorMessage = (state: RootState) => state.schoolType.error;
export const schoolTypeResponse = (state: RootState) =>
  state.schoolType.schoolTypeResponse;
